<template>
  <article
    class="notification | bg-white rounded-lg | p-16 | flow"
    data-type="comment"
  >
    <header>
      <p class="flex">
        <strong
          class="notification__type | font-medium text-primary"
          data-icon="comment"
          >Commentaire</strong
        >
        <span class="notification__client | text-grey-700"
          >{{ notification.project.title }}
          {{
            notification.project?.status === "unlisted" ? "(archivé)" : ""
          }}</span
        >
        <time
          datetime=""
          class="notification__date | text-grey-700 | ml-auto"
          >{{ formatDate(notification) }}</time
        >
      </p>
    </header>
    <p
      v-if="notification.type"
      class="notification__body | text-md font-medium | line-clamp"
    >
      {{
        notification.author.name
          ? notification.author.name
          : notification.author.email
      }}
      : {{ notification.text }}
    </p>
  </article>
</template>

<script setup>
import { useNotificationsStore } from "../../stores/notifications";

const { notification } = defineProps({ notification: Object });
const { formatDate } = useNotificationsStore();
</script>
